<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card
          title="Migration des mandats d'un créancier vers un autre créancier"
          class="bg-light shadow"
        >
          <b-row>
            <b-col lg="6">
              <mh-select
                class="mt-1"
                :table="table"
                field="sourceID"
                :autocomplete="{
                  field:
                    'creancier.nom_soc || creancier.(nom prenom) || creancier.ID',
                }"
                @change="getSourceCreditor()"
              ></mh-select>
              <b-card class="mt-3" v-if="source_creditor_loaded">
                <h6>
                  {{ source_creditor.nom_soc.value }}
                  <span v-if="source_creditor.nom.value"
                    >({{
                      (
                        source_creditor.prenom.value +
                        " " +
                        source_creditor.nom.value
                      ).trim()
                    }}) </span
                  >(#{{ source_creditor.ID.value }})
                  <b-button
                    @click="migrate()"
                    v-if="source_creditor_loaded && target_creditor_loaded"
                    variant="success"
                    size="sm"
                    class="float-right"
                    >Transférer
                    <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill
                  ></b-button>
                </h6>
                <template
                  v-if="source_creditor_loaded && target_creditor_loaded"
                >
                  <b-alert
                    class="clearfix mt-4"
                    show
                    variant="warning"
                    v-if="
                      source_creditor.tva.value != target_creditor.tva.value
                    "
                  >
                    Attention! Les deux numéros de TVA ne correspondent pas. Les
                    factures, relevés de compte ne seront pas migrés. Seuls les
                    mandats le seront.
                  </b-alert>
                  <b-alert v-else class="mt-4" show variant="success">
                    Les numéros de TVA correspondent. Les factures, relevés de
                    compte, documents, notes du créancier source seront
                    également migrés.
                  </b-alert>
                </template>

                <div v-if="source_creditor.warrants.length > 0">
                  <div
                    v-for="(hm, index) in source_creditor.warrants"
                    :key="index"
                  >
                    <div v-if="hm.mandats.length > 0">
                      <b-card-sub-title class="my-3">
                        {{ typeMandat(hm.mandats) }} du {{ toDate(hm.date) }}
                      </b-card-sub-title>
                      <table
                        class="
                          table
                          b-table
                          table-striped table-hover
                          b-table-fixed
                          table-sm
                        "
                      >
                        <tr v-for="(item, i) in hm.mandats" :key="i">
                          <td>{{ toDate(item.date_ouverture) }}</td>
                          <td>
                            <strong
                              ><b-link
                                :to="{
                                  name: 'warrantView',
                                  params: { id: item.ID },
                                }"
                                >{{ item.ID }}</b-link
                              ></strong
                            >
                          </td>
                          <td>{{ item.status_i18n }}</td>
                          <td>
                            <strong
                              ><b-link
                                v-if="item.status !== 'unused'"
                                :to="{
                                  name: 'debtorView',
                                  params: { id: item.debiteurID },
                                }"
                                >{{ item.debiteur }}</b-link
                              ></strong
                            >
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <b-alert show>Pas de mandat pour ce créancier</b-alert>
                </div>
              </b-card>
            </b-col>
            <b-col lg="6">
              <mh-select
                class="mt-1 mr-2"
                :table="table"
                field="targetID"
                :autocomplete="{
                  field:
                    'creancier.nom_soc || creancier.(nom prenom) || creancier.ID',
                }"
                @change="getTargetCreditor()"
              ></mh-select>
              <b-card class="mt-3" v-if="target_creditor_loaded">
                <h6>
                  {{ target_creditor.nom_soc.value }}
                  <span v-if="target_creditor.nom.value"
                    >({{
                      (
                        target_creditor.prenom.value +
                        " " +
                        target_creditor.nom.value
                      ).trim()
                    }})
                  </span>
                  (#{{ target_creditor.ID.value }})
                </h6>
                <div v-if="target_creditor.warrants.length > 0">
                  <div
                    v-for="(hm, index) in target_creditor.warrants"
                    :key="index"
                  >
                    <div v-if="hm.mandats.length > 0">
                      <b-card-sub-title class="my-3">
                        {{ typeMandat(hm.mandats) }} du {{ toDate(hm.date) }}
                      </b-card-sub-title>
                      <table
                        class="
                          table
                          b-table
                          table-striped table-hover
                          b-table-fixed
                          table-sm
                        "
                      >
                        <tr v-for="(item, i) in hm.mandats" :key="i">
                          <td>{{ toDate(item.date_ouverture) }}</td>
                          <td>
                            <strong
                              ><b-link
                                :to="{
                                  name: 'warrantView',
                                  params: { id: item.ID },
                                }"
                                >{{ item.ID }}</b-link
                              ></strong
                            >
                          </td>
                          <td>{{ item.status_i18n }}</td>
                          <td>
                            <strong
                              ><b-link
                                v-if="item.status !== 'unused'"
                                :to="{
                                  name: 'debtorView',
                                  params: { id: item.debiteurID },
                                }"
                                >{{ item.debiteur }}</b-link
                              ></strong
                            >
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <b-alert show>Pas de mandat pour ce créancier</b-alert>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import MhSelect from "@/components/MhSelect.vue";
import creditors from "@/services/creditors";
export default {
  name: "migrateWarrants",
  components: {
    MhSelect,
  },
  data() {
    return {
      busy: false,
      table: {
        sourceID: {
          label: "Créancier source",
          value: "",
          type: "int",
        },
        targetID: {
          label: "Créancier destination",
          value: "",
          type: "int",
        },
      },
      source_creditor: null,
      target_creditor: null,
      source_creditor_loaded: false,
      target_creditor_loaded: false,
      warrantsFields: [
        {
          key: "date_ouverture",
          label: "Date",
          sortable: true,
        },
        {
          key: "ID",
          label: "Numéro de mandat",
          sortable: true,
        },
        {
          key: "status_i18n",
          label: "Statut",
          sortable: true,
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
        },
      ],
      items: [
        {
          text: "Administration",
          to: { name: "administration" },
        },
        {
          text: "Migration des mandats",
        },
      ],
    };
  },
  methods: {
    async getSourceCreditor(id = null) {
      this.busy = true;
      this.source_creditor_loaded = false;
      if (id !== null) {
        this.table.sourceID.value = id;
      }
      if (this.table.sourceID.value == 0) return;
      await creditors.get(this.table.sourceID.value).then((response) => {
        this.source_creditor = response.data;
      });
      await creditors
        .warrants_info(this.table.sourceID.value)
        .then((response) => {
          this.source_creditor.warrants = response.data;
        });
      this.source_creditor_loaded = true;
      this.busy = false;
    },
    async getTargetCreditor(id = null) {
      this.busy = true;
      this.target_creditor_loaded = false;
      if (id !== null) {
        this.table.targetID.value = id;
      }
      if (this.table.targetID.value == 0) return;
      await creditors.get(this.table.targetID.value).then((response) => {
        this.target_creditor = response.data;
      });
      await creditors
        .warrants_info(this.table.targetID.value)
        .then((response) => {
          this.target_creditor.warrants = response.data;
        });
      this.target_creditor_loaded = true;
      this.busy = false;
    },
    typeMandat(hm) {
      if (hm.length > 1) {
        return "Carnet de " + hm.length + " mandats";
      }
      return "Mandat unique";
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    async migrate() {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir migrer ces mandats?", {
          cancelTitle: "Annuler",
          okTitle: "Migrer",
        })
        .then(() => {
          this.busy = true;

          creditors
            .warrants_migrate(
              this.table.sourceID.value,
              this.table.targetID.value
            )
            .then(() => {
              this.getSourceCreditor();
              this.getTargetCreditor();
            });
          this.busy = false;
        })
        .catch(() => {
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>